$(function () {
  // MV
  const swiper = new Swiper(".top_mv .swiper", {
      loop: true,
      effect: "fade", // フェード切り替え
      // 自動再生
      autoplay: {
          delay: 4000, // 4秒後に次のスライドへ
          disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
      },
      speed: 2000, // 2秒かけてフェード
  });
  //商品スライダー
  const mySwiper_thumb = new Swiper('.thumbnail_slider .swiper', {
      slidesPerView: 4,
      spaceBetween: 5,
      grabCursor: true,
      scrollbar: {
          el: '.thumbnail_slider .swiper-scrollbar',
          draggable: true,
      }, breakpoints: {
          769: {
              spaceBetween: 28,
          },
      },
  });
  const mySwiper_main = new Swiper('.gallery_slider .swiper', {
      effect: 'fade',
      fadeEffect: {
          crossFade: true,
      },
      thumbs: {
          swiper: mySwiper_thumb,
      },
  });
  //商品スライダーと中身の連動
  // 最初に.thumbの一番目の.swiper-slideの内容を取得
  var initialContent = $('.thumbnail_slider .swiper-slide:first-child .text').html();

  // mainの中身を最初の内容で初期化
  $('.gallery_slider').children('.text').html(initialContent);

  // thumb_listのliをクリックした時の処理
  $('.thumbnail_slider .swiper-slide').click(function () {
      // クリックされたliの内容を取得
      var clickedContent = $(this).children('.text').html();

      // mainの中身を書き換え
      // $('.gallery_slider').children('.text').html(clickedContent);
      // mainの中身をフェードアウトしてから書き換える
      $('.gallery_slider').children('.text').fadeOut('fast', function () {
          // 書き換え完了後にフェードインする
          $(this).html(clickedContent).fadeIn('fast');
      });
  });
});

AOS.init();
